import { render, staticRenderFns } from "./DragonVR.vue?vue&type=template&id=399baf7b&scoped=true"
import script from "./DragonVR.vue?vue&type=script&lang=js"
export * from "./DragonVR.vue?vue&type=script&lang=js"
import style0 from "./DragonVR.vue?vue&type=style&index=0&id=399baf7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399baf7b",
  null
  
)

export default component.exports